import React from 'react'
import styles from "./employerleave.module.css";


const TableTitle = () => {
  return (
    <>


    <div className = {styles.leaveText}>
          <h4 className ={styles.xlargeTextBold}>Leave Management</h4>
          {/* <i id="altPopup" class="fa-solid fa-circle-plus" onclick="openPopup()"></i> */}
        </div>

      
    </>
  )
}

export default TableTitle